




















































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import { Prop, Watch } from 'vue-property-decorator'
import TransactionGateWayView from '@/modules/transaction/components/shared/TransactionGateWayView.vue'
import PriceView from '@/modules/shared/components/shared/PriceView.vue'
import CopyableText from '@/modules/shared/components/shared/CopyableText.vue'
import MediaUploader from '@/modules/media/components/shared/MediaUploader.vue'
import MediaList from '@/modules/media/components/shared/MediaList.vue'
import { TicketResourceType } from '@/modules/ticket/models/ticket-resource.model'
import AdminDepartmentSearch from '@/modules/department/components/admin/AdminDepartmentSearch.vue'
import { TicketAnswerRequestModel } from '@/modules/ticket-answer/models/ticket-answer-request.model'
import { TicketAnswerCreateUseCase } from '@/modules/ticket-answer/use-cases/admin/ticket-answer-create.use-case'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import AdminPredefinedSearch from '@/modules/predefined-answer/components/admin/AdminPredefinedSearch.vue'
import EmojiPickerButton from '@/modules/shared/components/shared/EmojiPickerButton.vue'

@Component({
  components: {
    EmojiPickerButton,
    AdminPredefinedSearch,
    BaseInput,
    BaseButton,
    AdminDepartmentSearch,
    MediaList,
    MediaUploader,
    CopyableText,
    PriceView,
    TransactionGateWayView,
    BaseCard
  }
})
export default class AdminTicketNewAnswerForm extends Vue {
  constructor(
    private readonly useCase: TicketAnswerCreateUseCase
  ) {
    super()
  }

  @Prop({ default: false }) noPredefinedAnswers: boolean
  @Prop({ required: true }) ticket!: TicketResourceType
  protected answerRequest: TicketAnswerRequestModel = this.initRequest()
  predefinedAnswerSearchDefault: number[] = []
  predefinedAnswer: string = ''

  get ticketData() {
    return this.ticket.data
  }

  get isLoading() {
    return this.useCase.isLoading
  }

  addEmoji(emoji) {
    //console.log(emoji.native)
    this.answerRequest.message = `${this.answerRequest.message}${emoji.native}`
  }

  @Watch('predefinedAnswer')
  onPredefinedAnswerChange(newVal) {
    if (newVal !== '') {
      this.answerRequest.message =
        (this.answerRequest.message)
          ? `${this.answerRequest.message} \n ${newVal}`
          : newVal
      this.predefinedAnswer = ''
    }
  }

  protected setProperty(key, value) {
    this.$set(this.answerRequest, key, value)
  }

  setPredefined(key, value) {
    this.predefinedAnswer = (value) ? value : ''
  }

  onSubmit() {
    this.useCase.execute(this.ticketData.id, this.answerRequest).then(() => {
      if (this.useCase.isSuccess) {
        this.answerRequest = this.initRequest()
        this.predefinedAnswer = ''
      } else this.predefinedAnswer = ''
    })
  }

  initRequest(): TicketAnswerRequestModel {
    return {
      files: [],
      message: ''
    }
  }
}
